module.exports = __webpack_public_path__ + "static/media/match.30a54ea1.png";